
















































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import CFormGroup from '@/components/CFormGroup.vue';
import CFormInput from '@/components/CFormInput.vue';
import CFormHeading from '@/components/CFormHeading.vue';
import CFormSelect from './CFormSelect.vue';
import {
    customPropertiesUpdate,
    defaultCustomProperties
} from '@/custom-properties';
import ColorSuggestion from '@/components/ColorSuggestion.vue';
import CFormColorPicker from '@/components/CFormColorPicker.vue';
import { supportedCharactersArr } from '../../public/characters/abstract-avatars/supported-characters';
import FooterLinks from '@/components/FooterLinks.vue';
@Component({
    components: {
        FooterLinks,
        CFormColorPicker,
        ColorSuggestion,
        CFormInput,
        CFormGroup,
        CFormHeading,
        CFormSelect
    }
})
export default class EditorConfig extends Vue {
    @Prop()
    setName!: string;

    previewName = 'Austin';

    customProperties: any = defaultCustomProperties;

    setNameOptions = [
        {
            label: 'Abstract Avatars',
            value: 'abstract-avatars'
        },
        {
            label: 'Dark Avatars',
            value: 'dark-avatars'
        }
    ];

    borderStyleOptions = `none|dotted|dashed|solid`.split('|').map(item => {
        return {
            label: item,
            value: item
        };
    });

    colorPickerVisible: { [k: string]: boolean } = {
        '--avatar-background-color': false,
        '--avatar-border-color': false
    };

    inputTypes: { [k: string]: string } = {
        '--avatar-border-radius': 'number'
    };

    @Watch('customProperties', {
        deep: true,
        immediate: true
    })
    customPropertiesChange(value: any) {
        customPropertiesUpdate(value);
        this.$emit('change', value);
    }

    @Watch('previewName', {
        immediate: true
    })
    previewNameChange(value: string) {
        let character = value.charAt(0).toLowerCase();
        if (supportedCharactersArr.indexOf(character) === -1) {
            character = '_';
        }

        this.$emit('character', character);
    }

    getKeyToLabel(key: string) {
        const map: { [k: string]: string } = {
            '--avatar-border-color': 'Border Color',
            '--avatar-background-color': 'Background',
            '--avatar-border-width': 'Border Width',
            '--avatar-border-style': 'Border Style',
            '--avatar-border-radius': 'Border Radius'
        };

        return map[key] ?? key;
    }

    get customBorderProperties() {
        const items: any = {};
        Object.keys(this.customProperties).forEach(key => {
            if (key.indexOf('-border') > -1) {
                items[key] = this.customProperties[key];
            }
        });
        return items;
    }

    getValueMetricForKey(key: keyof typeof defaultCustomProperties) {
        const valueMetrics = {
            '--avatar-border-color': null,
            '--avatar-background-color': null,
            '--avatar-border-width': 'px',
            '--avatar-border-style': null,
            '--avatar-border-radius': 'px'
        };
        return valueMetrics[key];
    }

    get customBackgroundProperties() {
        const items: any = {};
        Object.keys(this.customProperties).forEach(key => {
            if (key.indexOf('-background') > -1) {
                items[key] = this.customProperties[key];
            }
        });
        return items;
    }
}
